import { render, staticRenderFns } from "./howtouse.vue?vue&type=template&id=17996730&scoped=true"
import script from "./howtouse.vue?vue&type=script&lang=js"
export * from "./howtouse.vue?vue&type=script&lang=js"
import style0 from "./howtouse.vue?vue&type=style&index=0&id=17996730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17996730",
  null
  
)

export default component.exports